import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Label } from "react-bootstrap";
import { fetchUnpaidRequests, clearRequests } from "actions/requests";
import { startPreloader, finishPreloader } from "actions/preloader";
import SortableTable from "containers/SortableTable";
import RequestListRow from "containers/RequestListRow";

class Payments extends Component {
  componentDidMount() {
    const { startPreloader, finishPreloader, fetchUnpaidRequests } = this.props;
    startPreloader();
    fetchUnpaidRequests().then(finishPreloader);
  }

  componentWillUnmount() {
    this.props.clearRequests();
  }

  handleSort(item, sortField) {
    return String(item[sortField]).toLowerCase();
  }

  render() {
    const { requests } = this.props;

    if (!requests || !requests.unpaid) return null;

    const { unpaid } = requests;

    const headerFields = [
      {
        title: "Invoice #",
        fieldname: "formatedtransactionnumber",
        function: "reqlink"
      },
      {
        title: "Request Type",
        fieldname: "requesttypeid",
        function: "reqtype"
      },
      { title: "Manufacturer", fieldname: "vendorname" },
      { title: "Model Name/Number", fieldname: "vendorproductname" },
      { title: "Billing Company", fieldname: "name" }
    ];

    return (
      <div>
        <h1 className="block-bottom-offset">
          Unpaid Certification Requests <Label>{unpaid.length}</Label>
        </h1>
        <SortableTable
          list={unpaid}
          header={headerFields}
          colNum={headerFields.length}
          handleSort={this.handleSort}
          RowRenderer={RequestListRow}
          renderLink={req => (
            <Link to={`/payments/${req.id}/add`}>
              {req.formatedtransactionnumber}
            </Link>
          )}
        />
      </div>
    );
  }
}

function mapStateToProps({ requests }) {
  return { requests };
}

export default connect(mapStateToProps, {
  fetchUnpaidRequests,
  clearRequests,
  startPreloader,
  finishPreloader
})(Payments);



// WEBPACK FOOTER //
// ./src/containers/request/Payments/index.js